import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { DBResponse } from "@/entities/IDBResponse";
import { NFT } from "@/entities/INFT";
import { NextGenCollection } from "@/entities/INextgen";
import { fetchAllPages, fetchUrl } from "@/services/6529api";
import { commonApiFetch } from "@/services/api/common-api";
import { useEffect, useState } from "react";
interface UseNFTCollectionsReturn {
  // Data
  nfts: NFT[]; // Memes + Gradients
  nextgenCollections: NextGenCollection[];

  // Loading state
  loading: boolean;
}
export function useNFTCollections(initialCollections) {
  const $ = _c(14);
  let t0;
  if ($[0] !== initialCollections?.nfts) {
    t0 = initialCollections?.nfts || [];
    $[0] = initialCollections?.nfts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [nfts, setNfts] = useState(t0);
  let t1;
  if ($[2] !== initialCollections?.nextgenCollections) {
    t1 = initialCollections?.nextgenCollections || [];
    $[2] = initialCollections?.nextgenCollections;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [nextgenCollections, setNextgenCollections] = useState(t1);
  const [loading, setLoading] = useState(!initialCollections);
  let t2;
  let t3;
  if ($[4] !== initialCollections) {
    t2 = () => {
      if (initialCollections && initialCollections.nfts.length > 0) {
        return;
      }
      fetchUrl(`${publicEnv.API_ENDPOINT}/api/memes_lite`).then(memeResponse => {
        setNfts(memeResponse.data);
        fetchAllPages(`${publicEnv.API_ENDPOINT}/api/nfts/gradients?&page_size=101`).then(gradients => {
          setNfts([...memeResponse.data, ...gradients]);
          setLoading(false);
        });
      });
    };
    t3 = [initialCollections];
    $[4] = initialCollections;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== initialCollections) {
    t4 = () => {
      if (initialCollections && initialCollections.nextgenCollections.length > 0) {
        return;
      }
      commonApiFetch({
        endpoint: "nextgen/collections"
      }).then(response => {
        setNextgenCollections(response.data);
      });
    };
    t5 = [initialCollections];
    $[7] = initialCollections;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== loading || $[11] !== nextgenCollections || $[12] !== nfts) {
    t6 = {
      nfts,
      nextgenCollections,
      loading
    };
    $[10] = loading;
    $[11] = nextgenCollections;
    $[12] = nfts;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}